import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
var _excluded = ["children", "classes"];
import React from 'react';
import PropTypes from 'prop-types';
import { default as withStyles } from '../styles';
import { default as MuiDialogContent } from '@mui/material/DialogContent';
import { spacing20 } from '../styles/tokens';
var styles = function styles() {
  return {
    root: {
      padding: spacing20
    }
  };
};

/**
 * DialogContent is the main content that lives within a Dialog.
 */
var DialogContent = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var children = props.children,
    classesProp = props.classes,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  var classes = {
    root: classesProp.root
  };
  return /*#__PURE__*/React.createElement(MuiDialogContent, _extends({
    classes: classes
  }, rest, {
    ref: ref
  }), children);
});
DialogContent.muiName = 'DialogContent';
DialogContent.displayName = 'DialogContent';
DialogContent.propTypes = {
  /**
   * The content of the component.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * 	The system prop that allows defining system overrides as well as additional CSS styles
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object])
};
export default withStyles(styles)(DialogContent);